import heb from './heb';
import eng from './eng';

export const getLabelsByLanguage = (language) => {
  return language === LANGUAGES.HE ? heb() : eng();
};

export const isRtlLanguage = (language) => {
  return language === LANGUAGES.HE;
};

export const getLanguageFromQueryParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const langFromParams = urlParams.get('language')?.toLowerCase() || LANGUAGES.EN;

  const allLanguages = Object.values(LANGUAGES);
  if (allLanguages.includes(langFromParams)) {
    return langFromParams;
  }

  return LANGUAGES.EN;
};

export const LANGUAGES = {
  HE: 'he',
  EN: 'en',
};
